import { apiEndpoints, SERVER_PATH } from '../endpoints.js'
import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'

export const getMachines = () => {
  const endpoint = `${apiEndpoints.machineConfigurations}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
